import type React from "react";
import SimpleNameTable from "../common/SimpleNameTable";
import CreateVendorForm from "./CreateVendorForm";

interface Vendor {
  _id: string;
  name: string;
}

interface VendorTableProps {
  items: Vendor[];
  loading?: boolean;
  onEdit?: (vendorId: string, newName: string) => Promise<void>;
  canEdit?: boolean;
}

const VendorTable: React.FC<VendorTableProps> = ({ items, loading, onEdit, canEdit = false }) => {
  return (
    <SimpleNameTable
      items={items}
      loading={loading}
      onEdit={onEdit}
      canEdit={canEdit}
      EditFormComponent={CreateVendorForm}
    />
  );
};

export default VendorTable;
